fx.ns("desktop.common.photoimport", class GooglePanel extends fx.components.ScreenPopup {

	constructor(data) {
		super(data);

		this.showClose = true;

		this._assets = fx.get("assets");
		this._service = fx.service("GoogleService");
	}


	// ------------- RENDER -------------- //   

	create() {
		super.create();

		// auth panel
		let text = fx.text("Si rien ne ne se passe après avoir cliqué sur le bouton de connexion, cela signifie que votre navigateur bloque les popups. Il vous suffit d'autoriser votre navigateur à afficher les popups pour résoudre le problème.");
		this.auth = new shared.social.AuthComponent({ social: "Google", icon: this._assets.googleConnectBtn, width: 232, height: 46, service: this._service, text: text, logo: this._assets.googleLogo });
		this.addChild(this.auth, { left: "center", top: "center", width: 350, height: 300 });

		this.exitButton2 = new fx.components.Button({ label: fx.text("Fermer"), className: 'button' });
		this.addChild(this.exitButton2, { bottom: 30, width: 200, left: "center" });
	}

	onReady() {
		super.onReady();

		this.on("click", this.onClose, this.exitButton2);
		this.on("error", this.onClose, this.auth);
	}

	// ------------- EVENTS -------------- //

	onDataEvent(event) {
		switch (event.type) {
			case "show-google-photos":
				this.removeChild(this.exitButton2, true);
				this.auth.hide();
				break;

			case "google-selected-photos-error":
			case "google-photos-error":
				this.loading(false);
				this.close();
				break;
			case "google-photos-startsession":
				this.auth.showPickerButton();
				break;
			case "google-photos-userinfos":
				if (event.data) {
					if (event.data.email)
						this.userText.text = fx.text('Connecté à Google Photos sur ') + event.data.email;
					if (event.data.picture)
						this.userAvatar.data = event.data.picture;
				}
				break;
		}
	}

});